module.exports = __webpack_public_path__ + "img/bid_thumb1.5a407265.png";